import $api from "../axios";
import { handleResponse } from "../../helpers/httpHelpers";

export const userAPI = {
  get,
  getAll,
  update,
  updateUserPermissions,
  disable,
  deactivate,
  activate,
  changePassword,
};

async function get(id) {
  try {
    return await $api.get(`/users/getById?id=${id}`);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function getAll() {
  try {
    return await $api.get(`/Users`);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function update(user) {
  try {
    return await $api.put(`/users/updateUser`, user);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function updateUserPermissions(userId, permissions) {
  try {
    return await $api.put(`/users/updateUserPermissions`, {id: userId, permissions});
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function disable(id) {
  try {
    return await $api.put(`/users/disableUser?id=${id}`);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function deactivate(id) {
  try {
    return await $api.put(`/users/deactivateUser?id=${id}`);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function activate(id) {
  try {
    return await $api.put(`/users/activateUser?id=${id}`);
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}

async function changePassword(currentPassword, newPassword) {
  try {
    return await $api.put(`/users/updatePassword`, {
      currentPassword,
      newPassword,
    });
  } catch (err) {
    return Promise.resolve(handleResponse(err.response));
  }
}
